import React from 'react';

import { H2, H3 } from '../../../components';
import { lazyLoadWithDimensions } from '../../../util/uiHelpers';

import connectImage from '../../LandingPage/SectionHowItWorks/images/connect.png';
import partyImage from '../../LandingPage/SectionHowItWorks/images/party.png';
import searchImage from '../../LandingPage/SectionHowItWorks/images/search.png';

import css from './SectionBookingFlow.module.css';
import classNames from 'classnames';

const Image = props => {
  const { alt, ...rest } = props;

  return <img {...rest} alt={alt} />;
};

const LazyImage = lazyLoadWithDimensions(Image, {
  loadAfterInitialRendering: 3000,
  maxWidth: '100px',
  maxHeight: '100px',
});

const items = [
  {
    image: searchImage,
    imagePosition: 'left',
    title: 'HowItWorksPage.flow.searchTitle',
    textItems: [
      'HowItWorksPage.flow.searchText.1',
      'HowItWorksPage.flow.searchText.2',
      'HowItWorksPage.flow.searchText.3',
    ],
  },
  {
    image: connectImage,
    imagePosition: 'right',
    title: 'HowItWorksPage.flow.connectTitle',
    textItems: [
      'HowItWorksPage.flow.connectText.1',
      'HowItWorksPage.flow.connectText.2',
      'HowItWorksPage.flow.connectText.3',
      'HowItWorksPage.flow.connectText.4',
      'HowItWorksPage.flow.connectText.5',
      'HowItWorksPage.flow.connectText.6',
    ],
  },
  {
    image: partyImage,
    imagePosition: 'left',
    title: 'HowItWorksPage.flow.partyTitle',
    textItems: ['HowItWorksPage.flow.partyText.1', 'HowItWorksPage.flow.partyText.2'],
  },
];

const SectionBookingFlow = props => {
  const { intl, className, titleClassName } = props;

  return (
    <div className={classNames(css.root, className)}>
      <H2 className={titleClassName}>
        {intl.formatMessage(
          { id: 'HowItWorks.theBookingFlowHeading' },
          { span: text => <span className={css.marketplaceColoredText}>{text}</span> }
        )}
      </H2>
      <div className={css.content}>
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <div
              className={classNames(css.flowItemWrapper, {
                [css.reversedRow]: item.imagePosition === 'right',
              })}
            >
              <div className={css.imageContainer}>
                <LazyImage className={css.image} src={item.image} alt="" />
              </div>
              <div>
                <H3 className={css.h3}>
                  {`${index + 1}.`}&nbsp;
                  {intl.formatMessage({ id: item.title })}
                </H3>
                <ul className={css.textList}>
                  {item.textItems.map(text => (
                    <li className={css.textItem} key={text}>
                      {intl.formatMessage({ id: text })}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            {index !== items.length - 1 && <hr className={css.divider} />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default SectionBookingFlow;
